import "../css/TeeStyles.css";
import imgLineOne from "../icons/assets/line-1.png";
import imgLineTwo from "../icons/assets/line-2.png";
import { Link } from "react-router-dom";
import React from "react";

const SectionFive: React.FC = () => {
  return (
    <div
      className="section linear-bg-mcm position-relative px-0"
      //   data-aos="flip-up"
      style={{ zIndex: 1 }}
    >
      <img
        src={imgLineOne}
        alt=""
        className="position-absolute"
        style={{ left: "3%", zIndex: 2 }}
      />
      <img
        src={imgLineTwo}
        alt=""
        className="position-absolute"
        style={{ right: "0%" }}
      />
      <div
        className="mx-auto"
        data-aos="fade-up"
        data-aos-easing="linear"
        data-aos-duration="900"
      >
        <span className="d-block text-center white fontSize32px boldFour pt-6 px-md-0 px-2">
          Start Creating magic Today!
        </span>
        <span className="fontSize20px d-block wid25 wid50Mobile pt-4 boldThree mx-auto text-center white">
          Reserve your session and bring your vision to life.
        </span>
        <Link
          to={"/bookings"}
          //   style={{ color: buttonColor, border: `solid 2px ${buttonColor}` }}
          className="fontSize16px white boldSix text-center d-block  rounded-4 pt-5 pb-4"
        >
          Book Now
        </Link>
      </div>
    </div>
  );
};

export default SectionFive;
